import { select } from '@ps/web-core-store';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { getCountries } from '@swf/core/utils/getCountries';
import countries from '@swf/generated/countries.json';

import type { Props as SelectProps } from '../Select/Select';
import Select from '../Select/Select';

import { TXTCLI_Country_of_Residence, TXTWCL_Find_my_country } from './CountrySelect.messages.json';
import { dropdownWrapper } from './CountrySelect.scss';
import Country from './components/Country/Country';

type Props = Partial<SelectProps> & {
  hideSelect?: boolean;
};

interface Component extends React.FC<React.PropsWithChildren<Props>> {
  Country: typeof Country;
}

export const findCountry = (lookupValue?: string) =>
  countries.find(({ value }: { value: string }) => value === lookupValue);

const CountrySelect: Component = ({
  children,
  name = 'country',
  title = TXTCLI_Country_of_Residence,
  ...props
}) => (
  <Select
    name={name}
    options={getCountries(useSelector(select.cms.getSiteId))}
    item={Country}
    title={title}
    searchLabel={TXTWCL_Find_my_country}
    className={classNames({ [dropdownWrapper]: props?.hideSelect })}
    {...props}
  >
    {children}
  </Select>
);

CountrySelect.Country = Country;

export default CountrySelect;
